import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInventory = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_66_3304)",
		stroke: "currentColor",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		children: [/* @__PURE__ */ _jsx("path", { d: "M17.188 13.695v-7.39a.632.632 0 0 0-.32-.547l-6.563-3.711a.61.61 0 0 0-.61 0l-6.562 3.71a.633.633 0 0 0-.32.548v7.39a.633.633 0 0 0 .32.547l6.562 3.711a.61.61 0 0 0 .61 0l6.562-3.71a.633.633 0 0 0 .32-.548v0Z" }), /* @__PURE__ */ _jsx("path", { d: "M10 12.813a2.813 2.813 0 1 0 0-5.626 2.813 2.813 0 0 0 0 5.625Z" })]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_66_3304",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h20v20H0z"
		})
	}) })]
});
export default SvgInventory;
